export const REVIEW_FEEDBACK_MANY_FETCHED = 'REVIEW_FEEDBACK_MANY_FETCHED';
export const REVIEW_FEEDBACK_ONE_FETCHED = 'REVIEW_FEEDBACK_ONE_FETCHED';
export const REVIEW_FEEDBACK_ADD = 'REVIEW_FEEDBACK_ADD';
export const REVIEW_FEEDBACK_UPDATE = 'REVIEW_FEEDBACK_UPDATE';
export const REVIEW_FEEDBACK_REMOVE = 'REVIEW_FEEDBACK_REMOVE';
export const REVIEW_FEEDBACK_UPDATE_NOT_VERIFIED_COUNT =
  'REVIEW_FEEDBACK_UPDATE_NOT_VERIFIED_COUNT';
